import { createSelector } from "@reduxjs/toolkit";
import { calcCreditValues } from "../../../../shared/lib/utils/calcCreditValues.js";
import { selectSlice } from "../../../../features/choice/model/selectors/selectSlice.js";
import { selectCreditLimits } from "./selectCreditLimits.js";
const selectInitialCreditLimits = createSelector([selectSlice, selectCreditLimits], (choice, creditLimits) => {
  if (!(creditLimits == null ? void 0 : creditLimits.data)) {
    return;
  }
  return calcCreditValues(choice, creditLimits.data);
});
export {
  selectInitialCreditLimits
};
